import { configureStore } from "@reduxjs/toolkit";
import activityLogsReducer from "./slices/activityLogSlice";
import authReducer from "./slices/authSlice";
import customerReducer from "./slices/customerSlice";
import employeeReducer from "./slices/employeeSlice";
import invoiceReducer from "./slices/invoiceSlice";
import paymentReducer from "./slices/paymentSlice";
import productReducer from "./slices/productSlice";
import returnReducer from "./slices/returnSlice";
import stockReducer from "./slices/stockSlice";
import themeReducer from "./slices/themeSlice";
import unitReducer from "./slices/unitSlice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    auth: authReducer,
    employees: employeeReducer,
    customers: customerReducer,
    products: productReducer,
    stock: stockReducer,
    units: unitReducer,
    invoices: invoiceReducer,
    returns: returnReducer,
    activityLogs: activityLogsReducer,
    payments: paymentReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
